export default __webpack_public_path__ + "static/media/postcard_back.de0d0e0f.jpg";